import { render } from "./IconHandle.vue?vue&type=template&id=536fa217"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconHandle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "536fa217"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('536fa217', __exports__)) {
    api.reload('536fa217', __exports__)
  }
  
  module.hot.accept("./IconHandle.vue?vue&type=template&id=536fa217", () => {
    api.rerender('536fa217', render)
  })

}


export default __exports__